module.exports = __webpack_public_path__ + "static/media/kite_surfing_1366.f29afd5c.webp";